/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const productDetailsContainerSX: SxProps<Theme> = (theme) => ({
	paddingX: theme.spacing(3),
	[theme.breakpoints.down(theme.breakpoints.values.xl + Number.parseInt(theme.spacing(3)))]: {
		marginX: theme.spacing(-3),
	},
});
